import React from "react";
import "./styles.css";

const InvestmentRoundScreen: React.FC = () => {
    return (
        <div className="gameTimeManagementContainer">
            <span
                className="gameTimeManagementText"
                style={{ marginRight: "32px" }}
            >
                <span className="gameComponentsTitle">
                    Investment Round Screen <span className="gameComponentsTitleTask">(Task 2)</span>
                </span>
                🅐 Shows the current game phase and the remaining time.
                <br /><br />
                🅑 Shows the time left in the investment round.
                <br /><br />
                🅒 Lets you choose your investment amount using the slider or by entering a number.
                <br /><br />
                🅓 Submits your selected investment.
                <br />
                <span style={{ color: '#dc2626', fontWeight: 700 }}>
                    Important: Click Invest before the timer ends, or your investment will not be recorded.
                </span>
                <br /><br />
                🅔 Displays the chat panel and messages from the discussion.
                <br /><br />
                🅕 Opens the game instructions if you need a reminder.
            </span>
            <img
                src={require("../../../../assets/components_1.png")}
                alt="Investment Round Screen"
                style={{ height: "60vh", alignSelf: 'flex-end' }}
            />
        </div>
    );
};

export default InvestmentRoundScreen;
